import axios from 'axios'

const axiosClient = axios.create({
  baseURL: process.env.VUE_APP_TODOKUSURI_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  auth: {
    username: process.env.VUE_APP_TODOKUSURI_API_USERNAME,
    password: process.env.VUE_APP_TODOKUSURI_API_PASSWORD
  }
})

export default axiosClient
